import React, { useState } from 'react';
import { CheckIcon, GiftIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { useSwipeable } from 'react-swipeable';
export const Bonuses = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const bonuses = [{
    title: 'Plantilla de Presupuesto Mensual',
    subtitle: 'Control Total del Mes',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9vzDKTAKEXZ4f1QFzpkkf8/ChatGPT_Image_15_nov_2025%2C_01_45_54_p.m..png',
    description: 'Una plantilla simple, clara y poderosa para que puedas organizar tu dinero cada mes sin estrés.',
    includes: ['Sección de ingresos (fijos + variables)', 'Gastos esenciales (servicios, alimentación, transporte, vivienda)', 'Gastos flexibles (entretenimiento, compras, extras)', 'Deudas (intereses + pagos mínimos + pagos acelerados)', 'Ahorro mensual automático', 'Porcentaje gastado vs. porcentaje ahorrado', 'Alerta de gastos innecesarios'],
    benefits: ['Identifica fugas de dinero en minutos', 'Controla tu dinero sin sentirte limitado', 'Te permite ver el panorama completo de tu economía', 'Te muestra cuántos meses tardarás en estabilizarte'],
    format: 'Versión imprimible (PDF) y versión editable (Google Sheets o Excel)',
    value: '$9.99'
  }, {
    title: 'Plan de Ahorro de 52 Semanas',
    subtitle: 'Desafío de Ahorro Latino',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vogxQN5NuMFvdw3cSArhVY/ChatGPT_Image_15_nov_2025%2C_01_53_13_p.m..png',
    description: 'Un sistema progresivo y realista que te ayuda a ahorrar durante todo el año, sin importar cuánto ganes.',
    includes: ['Modo fácil: Ahorros pequeños que aumentan lentamente', 'Modo estándar: Ahorro equilibrado, pensado para ingresos medios', 'Modo acelerado: Para quienes quieren retarse y ahorrar fuerte', 'Tablero de seguimiento semanal', 'Espacio para mini metas (viaje, deudas, fondo de emergencia, inversión)', 'Recordatorios de refuerzo motivacional', 'Hitos cada 13 semanas', 'Semana comodín para compensar cuando no puedas ahorrar'],
    benefits: ['Modalidad fácil: lograr entre $150 – $300 USD al año', 'Modalidad estándar: entre $300 – $600 USD', 'Modalidad acelerada: hasta $1,000 USD o más'],
    value: '$9.99'
  }, {
    title: 'Mini-guía',
    subtitle: 'Cómo Aumentar tus Ingresos sin Dejar tu Trabajo',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kTdzrckCF91mNUvmbijhDz/ChatGPT_Image_15_nov_2025%2C_01_56_29_p.m..png',
    description: 'Una guía corta pero poderosa que te enseña a generar más dinero sin renunciar a tu empleo actual.',
    includes: ['Parte 1: Cómo ganar más dentro de tu trabajo actual', 'Cómo negociar un aumento paso a paso', 'Cómo demostrar tu valor con métricas reales', 'Estrategias para ascender más rápido', 'El método de "micro-mejoras de desempeño"', 'Parte 2: Cómo generar ingresos alternos sin renunciar', 'Servicios digitales que puedes ofrecer con cero inversión', 'Mini-emprendimientos desde casa', 'Cómo convertir una habilidad en ingresos', 'Plataformas latinas para ganar extra', 'Parte 3: Métodos para aumentar tus ingresos en 30 días', 'Desafío de ingresos inteligentes', 'Estrategias rápidas para generar dinero inmediato', 'Cómo validar una idea antes de monetizarla'],
    benefits: ['Lista de habilidades monetizables', 'Plantilla para definir tu primera fuente de ingreso extra', 'Ejemplos de servicios reales que personas en LATAM ya están ofreciendo'],
    value: '$9.99'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % bonuses.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + bonuses.length) % bonuses.length);
  };
  const handlers = useSwipeable({
    onSwipedLeft: () => nextSlide(),
    onSwipedRight: () => prevSlide(),
    trackMouse: true
  });
  const BonusCard = ({
    bonus,
    index
  }: {
    bonus: (typeof bonuses)[0];
    index: number;
  }) => <div className="bg-white rounded-xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300 h-full" data-id="element-32">
      <div className="relative bg-gray-50" data-id="element-33">
        <img src={bonus.image} alt={bonus.title} className="w-full h-64 object-contain p-4" data-id="element-34" />
        <div className="absolute top-4 right-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 py-2 rounded-full shadow-lg" data-id="element-35">
          <p className="text-sm font-semibold" data-id="element-36">Bono #{index + 1}</p>
        </div>
      </div>
      <div className="p-6" data-id="element-37">
        <div className="mb-4" data-id="element-38">
          <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-39">
            {bonus.title}
          </h3>
          <p className="text-base text-orange-600 font-semibold mb-3" data-id="element-40">
            {bonus.subtitle}
          </p>
          <div className="flex items-center justify-between mb-3 bg-gradient-to-r from-orange-50 to-red-50 p-3 rounded-lg" data-id="element-41">
            <div data-id="element-42">
              <p className="text-xs text-gray-500 line-through" data-id="element-43">
                Valor: {bonus.value} USD
              </p>
              <p className="text-lg font-bold text-green-600" data-id="element-44">¡GRATIS HOY!</p>
            </div>
            <GiftIcon size={32} className="text-orange-600" data-id="element-45" />
          </div>
          <p className="text-gray-600 text-sm mb-4" data-id="element-46">{bonus.description}</p>
        </div>
        {bonus.includes && <div className="mb-4" data-id="element-47">
            <h4 className="font-semibold text-gray-900 mb-2 text-sm" data-id="element-48">
              Incluye:
            </h4>
            <ul className="space-y-1 max-h-32 overflow-y-auto" data-id="element-49">
              {bonus.includes.slice(0, 4).map((item, idx) => <li key={idx} className="flex items-start text-xs text-gray-600" data-id="element-50">
                  <CheckIcon size={14} className="text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-51" />
                  <span data-id="element-52">{item}</span>
                </li>)}
              {bonus.includes.length > 4 && <li className="text-xs text-orange-600 font-medium ml-5" data-id="element-53">
                  + {bonus.includes.length - 4} beneficios más...
                </li>}
            </ul>
          </div>}
        {bonus.format && <div className="bg-teal-50 p-3 rounded-lg mt-4" data-id="element-54">
            <p className="text-xs text-teal-800" data-id="element-55">
              <span className="font-semibold" data-id="element-56">Formato:</span> {bonus.format}
            </p>
          </div>}
      </div>
    </div>;
  return <section className="py-16 bg-gradient-to-b from-white to-orange-50" data-id="element-57">
      <div className="container mx-auto px-4" data-id="element-58">
        <div className="text-center mb-12" data-id="element-59">
          <div className="flex items-center justify-center mb-4" data-id="element-60">
            <GiftIcon size={40} className="text-orange-600 mr-3" data-id="element-61" />
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900" data-id="element-62">
              Bonos Exclusivos
            </h2>
          </div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-6" data-id="element-63">
            Cuando adquieres el método hoy, recibes estos 3 bonos de forma
            completamente gratuita
          </p>
          <div className="inline-block bg-gradient-to-r from-orange-100 via-red-100 to-orange-100 px-8 py-4 rounded-2xl shadow-lg" data-id="element-64">
            <div className="flex flex-col md:flex-row items-center justify-center gap-4" data-id="element-65">
              <div className="text-center" data-id="element-66">
                <p className="text-sm text-gray-600 mb-1" data-id="element-67">Valor Individual</p>
                <p className="text-2xl font-bold text-gray-400 line-through" data-id="element-68">
                  $29.97 USD
                </p>
              </div>
              <div className="hidden md:block text-3xl text-orange-600 font-bold" data-id="element-69">
                →
              </div>
              <div className="text-center bg-white px-6 py-3 rounded-xl shadow-md" data-id="element-70">
                <p className="text-sm text-green-600 font-semibold mb-1" data-id="element-71">
                  ¡GRATIS CON TU COMPRA!
                </p>
                <p className="text-3xl font-bold text-orange-600" data-id="element-72">$0.00 USD</p>
              </div>
            </div>
          </div>
        </div>
        <div className="hidden md:grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto mb-12" data-id="element-73">
          {bonuses.map((bonus, index) => <BonusCard key={index} bonus={bonus} index={index} data-id="element-74" />)}
        </div>
        <div className="md:hidden relative mb-12" data-id="element-75">
          <div {...handlers} className="overflow-hidden" data-id="element-76">
            <div className="flex transition-transform duration-300 ease-in-out" style={{
            transform: `translateX(-${currentSlide * 100}%)`
          }} data-id="element-77">
              {bonuses.map((bonus, index) => <div key={index} className="w-full flex-shrink-0 px-4" data-id="element-78">
                  <BonusCard bonus={bonus} index={index} data-id="element-79" />
                </div>)}
            </div>
          </div>
          <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100 transition-colors z-10" aria-label="Bono anterior" data-id="element-80">
            <ChevronLeftIcon size={24} className="text-gray-700" data-id="element-81" />
          </button>
          <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100 transition-colors z-10" aria-label="Siguiente bono" data-id="element-82">
            <ChevronRightIcon size={24} className="text-gray-700" data-id="element-83" />
          </button>
          <div className="flex justify-center gap-2 mt-6" data-id="element-84">
            {bonuses.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2 h-2 rounded-full transition-all ${currentSlide === index ? 'bg-orange-600 w-8' : 'bg-gray-300'}`} aria-label={`Ir al bono ${index + 1}`} data-id="element-85" />)}
          </div>
        </div>
        <div className="mt-12 max-w-4xl mx-auto" data-id="element-86">
          <div className="bg-gradient-to-br from-orange-500 to-red-600 text-white p-8 rounded-2xl shadow-2xl" data-id="element-87">
            <h3 className="text-2xl md:text-3xl font-bold mb-6 text-center" data-id="element-88">
              Resumen de tu Inversión Hoy
            </h3>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-6" data-id="element-89">
              <div className="space-y-3" data-id="element-90">
                <div className="flex justify-between items-center pb-2 border-b border-white/20" data-id="element-91">
                  <span className="text-lg" data-id="element-92">Método principal:</span>
                  <span className="text-lg line-through opacity-75" data-id="element-93">
                    $29.99 USD
                  </span>
                </div>
                <div className="flex justify-between items-center pb-2 border-b border-white/20" data-id="element-94">
                  <span className="text-lg" data-id="element-95">Bonos (3 guías):</span>
                  <span className="text-lg line-through opacity-75" data-id="element-96">
                    $29.97 USD
                  </span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b-2 border-white/40" data-id="element-97">
                  <span className="text-xl font-semibold" data-id="element-98">Valor total:</span>
                  <span className="text-xl font-semibold line-through opacity-75" data-id="element-99">
                    $59.96 USD
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-white text-gray-900 rounded-xl p-6 text-center" data-id="element-100">
              <p className="text-sm text-gray-600 mb-2" data-id="element-101">
                Tu precio especial de hoy
              </p>
              <p className="text-5xl md:text-6xl font-bold text-orange-600 mb-3" data-id="element-102">
                $9.99 <span className="text-2xl" data-id="element-103">USD</span>
              </p>
              <div className="inline-block bg-green-100 px-6 py-2 rounded-full" data-id="element-104">
                <p className="text-green-700 font-bold text-lg" data-id="element-105">
                  ¡Ahorras $49.97 USD!
                </p>
                <p className="text-green-600 text-sm font-semibold" data-id="element-106">
                  (83% de descuento)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};